export default __webpack_public_path__ + "static/media/nerveLogo.0ba5c4f4.png";